module.exports = __webpack_public_path__ + "static/MadeByCF-d738c71a95b18e3f8dc7be8b5933c41d.png";